import LayoutPublicJobs from "../../layouts/PublicJobs.vue";
import layout from "@/layouts/PublicJobs.vue";
export const routes = (parentName) => {
  return [
    {
      path: "/jobs",
      component: layout,
      children: [
        {
          path: "",
          name: `${parentName}`,
          component: () => import("./Index.vue"),
          children: [
            {
              path: "search-cv",
              name: `${parentName}-Search-Cv`,
              component: () => import("./SearchCv.vue"),
              props: (route) => ({
                step: route.query.step,
              }),
            },

            {
              path: "search-cv/:id",
              name: `${parentName}-Search-Cv-Item`,
              component: () => import("./SearchCvItem.vue"),
              props: (route) => ({
                step: route.query.step,
              }),
            },

            {
              path: "search-positions",
              name: `${parentName}-Search-Positions`,
              component: () => import("./SearchPositions.vue"),
              props: (route) => ({
                step: route.query.step,
              }),
            },
            {
              path: "search-positions/:id",
              name: `${parentName}-Search-Positions-Item`,
              component: () => import("./SearchPositionsItem.vue"),
              props: (route) => ({
                step: route.query.step,
              }),
            },
            {
              path: "companies/:id",
              name: `${parentName}-Companies`,
              component: () => import("./Companies.vue"),
              props: (route) => ({
                step: route.query.step,
              }),
            },
          ],
        },
      ],
    },
  ];
};
